<template>
  <div>
    <el-form-item label="选项配置值">
      <div v-for="(item, index) in selectConfig">
        <el-checkbox v-model="item.is_selected" :true-label="1" :false-label="0" v-if="!chooseMultiply" @change="selectValueChange(item, index)">默认选中</el-checkbox>
        <el-checkbox v-model="item.is_selected" :true-label="1" :false-label="0" v-if="chooseMultiply" @change="judgeMaxCount(item, index)">默认选中</el-checkbox>
        <br>
        <el-input type="number" v-model.number="item.value" placeholder="选项值" class="h-40 w-100"  v-show="!onlyName"></el-input>
        <el-input v-model.trim="item.name" placeholder="选项名称" class="h-40 w-100"></el-input>
        <el-button size="small" type="danger" @click="deleteConfig(item, index)">删除</el-button>
        <el-button size="small" type="primary" @click="sortUp(index)" :disabled="index == 0">上移</el-button>
        <el-button size="small" type="primary" @click="sortDown(index)" :disabled="index == selectConfig.length - 1">下移</el-button>
      </div>
      <div class="form-tips" v-show="selectConfig.length">选项值为0代表空值</div>
      <div>
        <el-button type="primary" @click="addConfig()">添加</el-button>
        <el-button type="primary" @click="openImportConfigDialog()">导入选项</el-button>
      </div>
    </el-form-item>
  </div>
</template>

<script>
  import importConfigDialog from './importConfigDialog.vue'
  export default {
    props: ['curInput', 'selectConfig', 'onlyName', 'chooseMultiply', 'maxCount'],
    data() {
      return {
        selectCount: 0,
        inputChange: false,
        isImportConfig: false
      }
    },
    created() {
      this.initSelectCount()
    },
    methods: {
      openImportConfigDialog() {
        store.dispatch('openImportDialog', true)
      },
      initSelectCount() {
        let count = 0
        _(this.selectConfig).forEach((res) => {
          if (res.is_selected) {
            count++
          }
        })
        this.setSelectCount(count)
      },
      addConfig() { // 添加配置
        if (this.onlyName) {
          this.selectConfig.push({ name: '', is_selected: 0 })
        } else {
          this.selectConfig.push({ value: '', name: '', is_selected: 0 })
        }
      },
      deleteConfig(item, index) { // 删除配置
        if (item.is_selected) {
          this.setSelectCount(this.selectCount - 1)
        }
        this.selectConfig.splice(index, 1)
      },
      selectValueChange(item, index) { // 不是多选时，选中一个默认取消另一个选择
        _(this.selectConfig).forEach((res, key) => {
          if (key != index) {
            res.is_selected = 0
          }
        })
      },
      resetSelectValue() { // 重置所有选项的选中状态
        _(this.selectConfig).forEach((res, key) => {
          res.is_selected = 0
        })
      },
      judgeMaxCount(item, index) { // 判断默认选中数是否大于最大限制
        if (item.is_selected) {
          this.selectCount++
        } else {
          this.selectCount--
        }
        if (this.maxCount && this.selectCount > this.maxCount) {
          item.is_selected = 0
          this.selectCount--
          _g.toastMsg(this, 'error', '默认选中数不能大于最多选择限制')
        }
      },
      setInputChange(value) { // 设置inputChange状态值
        this.inputChange = value
      },
      setSelectCount(count) { // 设置选中数量值
        this.selectCount = count
      },
      sortUp(index) { // 上移
        let config = this.selectConfig
        let temp = config[index]
        config.splice(index, 1)
        config.splice(index - 1, 0, temp)
      },
      sortDown(index) { // 下移
        let config = this.selectConfig
        let temp = config[index]
        config.splice(index, 1)
        config.splice(index + 1, 0, temp)
      }
    },
    watch: {
      'curInput'() {
        this.setInputChange(true)
        this.initSelectCount()
      },
      'maxCount'() {
        if (this.inputChange) {
          return
        }
        if (this.maxCount && this.maxCount < this.selectCount) {
          this.resetSelectValue()
          this.setSelectCount(0)
        }
      },
      'inputChange'() {
        if (this.inputChange) {
          this.setInputChange(false)
        }
      }
    },
    components: {
      importConfigDialog
    }
  }
</script>


// WEBPACK FOOTER //
// optionConfig.vue?ba3d0b32